// extracted by mini-css-extract-plugin
export var __wab_expr_html_text = "plasmic-module--__wab_expr_html_text--1145a";
export var a = "plasmic-module--a--ff7d6";
export var address = "plasmic-module--address--b4c2b";
export var all = "plasmic-module--all--2d2b4";
export var blockquote = "plasmic-module--blockquote--988c8";
export var button = "plasmic-module--button--545ff";
export var code = "plasmic-module--code--b01ff";
export var h1 = "plasmic-module--h1--d103c";
export var h2 = "plasmic-module--h2--740b1";
export var h3 = "plasmic-module--h3--1ba9d";
export var h4 = "plasmic-module--h4--bc504";
export var h5 = "plasmic-module--h5--435ab";
export var h6 = "plasmic-module--h6--579c9";
export var img = "plasmic-module--img--7d00f";
export var input = "plasmic-module--input--ec4ce";
export var li = "plasmic-module--li--e4fec";
export var ol = "plasmic-module--ol--50320";
export var p = "plasmic-module--p--4605f";
export var plasmic_default__component_wrapper = "plasmic-module--plasmic_default__component_wrapper--ae5bc";
export var plasmic_default__inline = "plasmic-module--plasmic_default__inline--1cc5d";
export var plasmic_default_styles = "plasmic-module--plasmic_default_styles--77866";
export var plasmic_mixins = "plasmic-module--plasmic_mixins--071ea";
export var plasmic_page_wrapper = "plasmic-module--plasmic_page_wrapper--922f9";
export var plasmic_tokens = "plasmic-module--plasmic_tokens--7b07c";
export var pre = "plasmic-module--pre--d43ef";
export var root_reset = "plasmic-module--root_reset--2daae";
export var root_reset_tags = "plasmic-module--root_reset_tags--bfc34";
export var select = "plasmic-module--select--c9a97";
export var span = "plasmic-module--span--fd1f4";
export var textarea = "plasmic-module--textarea--586b5";
export var ul = "plasmic-module--ul--0e4c5";